import {useEffect} from 'react';
import {forbidExtraProps} from 'airbnb-prop-types';
import {any} from 'prop-types';
import {ModalsContext} from 'r/contexts';
import {useStateReducer, unionContexts} from 'r/utils';


export default unionContexts(
  ModalsProvider,
);

ModalsProvider.propTypes = forbidExtraProps({
  children: any.isRequired,
});

function ModalsProvider({
  children,
}) {
  const [{
    modals,
  }, ss] = useStateReducer({
    modals: [],
  });

  const pushModal = ({prevModalScrollTop, ...modal}) => {
    ss(state => {
      const prevModal = state.modals.slice(-1)[0];
      if (prevModal) {
        prevModal.scrollTop = prevModalScrollTop;
      }
      return {modals: [...state.modals, modal]};
    });
  };

  const removeModal = _id => {
    ss(state => ({modals: state.modals.filter(({id}) => id !== _id)}));
  };


  const value = {
    modals,
    pushModal,
    removeModal,
  };


  useEffect(() => {
    window.__r__debugModalsContextValue = value; // eslint-disable-line no-restricted-syntax
  }, [value]);


  return (
    <ModalsContext.Provider value={value}>
      {children}
    </ModalsContext.Provider>
  );
}
